{
  "name": "jretail-basic",
  "version": "1.0.17",
  "scripts": {
    "ng": "ng",
    "start": "ng serve --port 8085 --host 0.0.0.0",
    "build": "ng build",
    "build-prod": "ng build --configuration production",
    "build-dev": "ng build --configuration dev",
    "kill-port": "npx kill-port 8085",
    "watch": "ng build --watch --configuration development",
    "test": "ng test",
    "test:ng": "ng test --browsers=chromium",
    "test:ng:ci": "ng test --no-watch --browsers=chromium",
    "test:unit": "vitest",
    "test:unit:watch": "vitest --watch",
    "test:unit:ui": "vitest --ui",
    "test:unit:coverage": "vitest --coverage",
    "test:e2e": "playwright test",
    "test:e2e:ui": "playwright test --ui",
    "test:e2e:ui:chromium": "playwright test --ui --project=chromium",
    "test:e2e:headed": "playwright test --headed",
    "test:e2e:debug": "playwright test --debug",
    "prettier": "npx prettier --write \"src/**/*.{ts,html}\"",
    "lint": "eslint \"src/**/*.ts\""
  },
  "private": true,
  "packageManager": "npm@10.8.2",
  "dependencies": {
    "@angular/animations": "^21.1.5",
    "@angular/cdk": "^21.1.1",
    "@angular/common": "^21.1.5",
    "@angular/compiler": "^21.1.5",
    "@angular/core": "^21.1.5",
    "@angular/forms": "^21.1.5",
    "@angular/platform-browser": "^21.1.5",
    "@angular/router": "^21.1.5",
    "@angular/service-worker": "^21.1.5",
    "@ngx-translate/core": "^17.0.0",
    "@ngx-translate/http-loader": "^17.0.0",
    "@ngxs/store": "^21.0.0",
    "@phosphor-icons/web": "^2.1.2",
    "@primeng/themes": "^21.0.4",
    "@sentry/angular": "^10.47.0",
    "@syncfusion/ej2-angular-spreadsheet": "^34.2.8",
    "@syncfusion/ej2-base": "^34.2.8",
    "@syncfusion/ej2-locale": "^34.2.2",
    "@syncfusion/ej2-pivotview": "^34.2.9",
    "bootstrap": "^5.3.8",
    "crypto-js": "^4.2.0",
    "jszip": "^3.10.1",
    "keycloak-angular": "^21.0.0",
    "keycloak-js": "^25.0.6",
    "mixpanel-browser": "^2.83.0",
    "ngx-image-cropper": "^9.1.6",
    "prettier": "^3.8.1",
    "primeicons": "^7.0.0",
    "primeng": "^21.1.0",
    "rxjs": "~7.8.0",
    "tslib": "^2.3.0",
    "xlsx": "^0.18.5",
    "xlsx-js-style": "^1.2.0"
  },
  "devDependencies": {
    "@angular/build": "^21.1.4",
    "@angular/cli": "^21.1.4",
    "@angular/compiler-cli": "^21.1.5",
    "@eslint/js": "^9.39.2",
    "@playwright/test": "^1.59.1",
    "@types/crypto-js": "^4.2.2",
    "@types/node": "^25.5.2",
    "@vitest/browser": "^4.1.2",
    "@vitest/browser-playwright": "^4.1.2",
    "docx": "^9.6.1",
    "eslint": "^9.39.2",
    "jsdom": "^27.1.0",
    "typescript": "~5.9.2",
    "typescript-eslint": "^8.50.0",
    "vitest": "^4.0.8"
  }
}
